import { Maximize } from "lucide-react";

interface TraceLoadingAnimationProps {
    displayText: string;
    subTitle: string;
  }

  
// Custom CSS for the animated pulse effect using Metronic Blue #3699FF
const loaderStyles = `
@keyframes pulse-ring {
  0% { transform: scale(0.33); opacity: 1; }
  80%, 100% { transform: scale(1.1); opacity: 0; }
}
.trace-loader-ring {
  position: absolute;
  width: 80px;
  height: 80px;
  border: 4px solid #3699FF;
  border-radius: 50%;
  animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}
`;

export const TraceLoadingAnimation = (props: TraceLoadingAnimationProps) => { 
    return (
    <div className="text-center p-10 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '250px' }}>
        <style>{loaderStyles}</style>
        <div className="position-relative d-flex align-items-center justify-content-center" style={{ width: '100px', height: '100px' }}>
            {/* Animated Rings - #3699FF */}
            <div className="trace-loader-ring" style={{ animationDelay: '0s' }}></div>
            <div className="trace-loader-ring" style={{ animationDelay: '-0.4s' }}></div>
            
            {/* Central Circle - Border #3699FF */}
            <div className="position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center border border-2 shadow-sm" 
                    style={{ width: '60px', height: '60px', zIndex: 1, borderColor: '#3699FF' }}>
                
                <Maximize size={24} className="position-absolute opacity-10" style={{ color: '#3699FF' }} />
                
                {/* Black Counter Text perfectly centered */}
                <span className="mb-0 d-flex align-items-center justify-content-center font-weight-bolder" 
                        style={{ 
                            lineHeight: 1, 
                            fontSize: '1.5rem', 
                            color: '#000000' 
                        }}>
                    {props.displayText}
                </span>
            </div>
        </div>
        <div className="mt-5 text-muted font-weight-bold">{props.subTitle}</div>
    </div>
    );
}